var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 19.0003H17.5M3.166 11.1873C2.73962 11.6147 2.50011 12.1937 2.5 12.7973V16.0003H5.723C6.327 16.0003 6.906 15.7603 7.333 15.3323L16.833 5.82734C17.2592 5.39993 17.4986 4.82095 17.4986 4.21734C17.4986 3.61372 17.2592 3.03474 16.833 2.60734L15.895 1.66734C15.6835 1.45569 15.4323 1.28781 15.1558 1.1733C14.8794 1.0588 14.583 0.999907 14.2838 1C13.9846 1.00009 13.6883 1.05917 13.4119 1.17385C13.1355 1.28852 12.8844 1.45656 12.673 1.66834L3.166 11.1873Z",
    stroke: "#20232D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.2d6dd1f0c759e0aca6afdefbf534f35c.svg";
export { ForwardRef as ReactComponent };